<template>
  <div class="cc-input-box">
    <label class="cc-label" v-if="title">{{title}}</label>
    <!-- input 图标 -->
    <!--
    <slot name="icon">
        <i class="cc-input-icon"
            :class="[
                'cc-icon' + icon,
                onIconClick ? 'is-clickable' : ''
            ]"
            v-if="icon"
            @click="handleIconClick"
        ></i>
    </slot>-->
    <div class="cc-input-content" :style="styleObject">
      <input type="text"
             class="cc-input"
             ref = "input"
             :autocomplete = "autoComplete"
             :value = "currentValue"
             :readonly = "readonly"
             :disabled = "disabled"
             :placeholder = "placeholder"

             @input = "handleInput"
             @focus = "handleFocus"
             @blur = "handleBlur"
             :pattern = "validator"
             :style="styleObject"
             :class="{errorBorder: error}"
      >
      <i v-if="isDeleteBtn && !disabled" class="cc-input-icon-delet" v-show="currentValue" @click="handleIconClick"></i>
      <ul v-if="showInputList && inputlistdata && inputlistdata.length" class="cc-input-list" :style="styleObject">
        <li v-for="(item,index) in inputlistdata"  :key="index" @click="handleSelect(item)" class="cc-input-item">
          <slot name="itemText" :item="item"></slot>
        </li>
      </ul>

    </div>

  </div>

</template>

<script>
  import { isEmptyObject, cloneObjects } from '@/utils/assist'
  export default{
    name: 'Input'
    ,props: {
      title:String
      ,value: [String,Number]
      ,placeholder: String
      ,width:{
        type:Number
        ,default:160
      }
      ,styleObj:Object//自定义input样式，【主要用于响应式,使用方式 :styleObj = {maxWidth:'300px',minWidth:'100px',width:'100%'}，如需label和input在一行显示，在父组件中，该组件需设置style="display:flex"】
      ,readonly: Boolean
      //,icon: String
      ,disabled: Boolean
      ,autoComplete:{
        type:String
        ,default:'off'
      }
      //,oniconclick: Function
      ,inputlistdata:Array
      ,validator:RegExp
      ,showinputlist:{
        type:Boolean,
        default:false
      }
      ,isDeleteBtn:{
        type:Boolean,
        default: true
      }
      ,error: Boolean
    }
    ,watch: {
      'value'(val,oldValue){
        this.setCurrentValue(val);
      }
    }
    ,data(){
      return {
        currentValue: this.value
        ,showInputList: this.showinputlist
      }
    }
    ,computed:{
      styleObject:function(){
        let _style={};
        if(this.width){
          _style.width = this.width + 'px';
        }
        if(isEmptyObject(this.styleObj)){
          return _style;
        }else{
          return cloneObjects(_style,this.styleObj);
        }
      }
    }
    ,methods:{
      handleBlur(event){
        setTimeout(()=>{
          this.showInputList = false;
          this.$emit('blur',event);
        },200);
      }
      ,handleFocus(event){
        if(typeof this.showinputlist !== 'undefined'){
          this.showInputList = true;
        }
        this.$emit('focus',event.target.value);
      }
      ,handleInput(event){
        const value = event.target.value;
        this.$emit('input',value);
        this.setCurrentValue(value);
        this.$emit('change',value);
      }
      ,handleIconClick(event){
        /*if(this.oniconclick){
            this.oniconclick(event);
        }*/
        this.currentValue = '';
        this.$emit('input','');
        this.$emit('change','');
        event.target.parentElement.querySelector('input').focus();
      }
      ,setCurrentValue(value){
        if(value === this.currentValue) return;
        this.currentValue = value;
      }
      ,handleSelect(item){
        this.$emit('select',item);
      }
    }
  }
</script>

<style>
  .cc-input-box{
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    /*position:relative;*/
  }
  .cc-input-box .cc-label{
    font-size: 14px;
  }
  .cc-input-box .cc-input-content{
    display:inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    position:relative;
  }
  .cc-input-content .cc-input{
    height: 30px;
    border: 1px solid #59738c;
    padding: 0 25px 0 10px;
  }
  .cc-input-content .cc-input.errorBorder{
    border: 1px solid red;
  }
  .cc-input-content .cc-input[disabled] {
    border: 1px solid #e6e6e6
  }
  .cc-input-content .cc-input-icon-delet{
    position: absolute;
    width: 16px;
    height: 16px;
    display: inline-block;
    top: 7px;
    right: 5px;
  }
  .cc-input-content .cc-input-icon-delet:before{
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
    height: 2px;
    background-color: #979797;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .cc-input-content .cc-input-icon-delet:after{
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
    height: 2px;
    background-color: #979797;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  .cc-input-content .cc-input-list{
    position: absolute;
    right: 0;
    top: 29px;
    z-index: 9998;
    background:#fff;
    border: 1px solid #59738c;
    overflow: auto;
    max-height: 180px;
  }
  .cc-input-content .cc-input-list::-webkit-scrollbar {
    width: 5px;
    background-color: #dde0e3;
  }
  .cc-input-content .cc-input-list::-webkit-scrollbar-thumb {
    background-color: #3b5d8b;
  }
  .cc-input-content .cc-input-item{
    padding:0 10px;
    line-height:30px;
  }
  .cc-input-content .cc-input-item:hover{
    background-color: #d1dfe3;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// components/Cc-Input/Input.vue